import SyncRoundedIcon from '@mui/icons-material/SyncRounded';
import AspectRatioRounded from '@mui/icons-material/AspectRatioRounded';
import { Box, IconButton, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { fieldboxKpiAccessLevels, USER_TYPE } from '../../../../utils/constants';
import useSyncMobileDevices from '../../../../hooks/useSyncMobileDevices';
import SyncMobileDevicesModal from './SyncMobileDevicesModal';
import CardMedia from '@mui/material/CardMedia';
import Premium from '../../../../assets/images/PRO logo PMS green only.svg';
import { useState } from 'react';
import { REDUX_ACTIONS } from '../../../../shared/config/constants';
import styles from './styles';
import useAspectRatio from '../../../../hooks/useAspectRatio';
import { LocalShippingRounded, PieChartOutlineOutlined, Storefront } from '@mui/icons-material';
import { epicorSyncShipsTo } from '../../../../store/actions/epicor/epicorSyncShipsTo';
import { epicorSyncCustomers } from '../../../../store/actions/epicor/epicorSyncCustomers';
import { containsAnyKeys } from '../../../../utils/objectHelpers';
import { isMobile } from 'react-device-detect';

const syncMobilePermitedRoles = [
  USER_TYPE.PREMIUM_ADMIN,
  USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN,
];

const SyncMobileDevices = () => {
  const [open, setOpen] = useState(false);
  const [openSyncShipsTo, setOpenSyncShipsTo] = useState(false);
  const [openSyncCustomers, setOpenSyncCustomers] = useState(false);
  const classes = styles();
  const user = useSelector((state) => state.currentUser);
  const epicorBins = useSelector((state) => state.epicorBins);
  const syncMobileDevices = useSelector((state) => state.epicorSyncMobileDevices);
  const dispatch = useDispatch();
  const isAdminUser = syncMobilePermitedRoles.includes(user.type) || (user.type === USER_TYPE.PREMIUM_SELECT_ADMIN && containsAnyKeys(syncMobilePermitedRoles, user.accessLevels));
  const userKpiAccess = fieldboxKpiAccessLevels.includes(user.type) || (user.type === USER_TYPE.PREMIUM_SELECT_ADMIN && containsAnyKeys(fieldboxKpiAccessLevels, user.accessLevels));

  const handleAspectRatio = useAspectRatio();
  const { preferences } = useSelector((state) => state.currentUser);

  const handleOpenModal = () => {
    setOpen(true);
    dispatch({
      type: REDUX_ACTIONS.EPICOR_SYNC_MOBILE_DATA_IDLE,
      payload: {
        message: '',
      },
    });
  };

  const handleCloseModal = () => {
    setOpen(false);
    dispatch({
      type: REDUX_ACTIONS.EPICOR_SYNC_MOBILE_DATA_IDLE,
      payload: {
        message: '',
      },
    });
  };

  const handleSyncMobileDevices = useSyncMobileDevices();

  const handleOpenSyncShipsToModal = () => {
    setOpenSyncShipsTo(true);
    dispatch({
      type: REDUX_ACTIONS.EPICORE_RIGS_SYNC_SHIPSTO_IDLE,
      payload: {
        message: '',
      },
    });
  };

  const handleCloseSyncShipsToModal = () => {
    setOpenSyncShipsTo(false);
    dispatch({
      type: REDUX_ACTIONS.EPICORE_RIGS_SYNC_SHIPSTO_IDLE,
      payload: {
        message: '',
      },
    });
  };

  const handleSyncShiptsTo = () => {
    dispatch(epicorSyncShipsTo());
  };

  const handleOpenSyncCustomerModal = () => {
    setOpenSyncCustomers(true);
    dispatch({
      type: REDUX_ACTIONS.EPICOR_RIGS_SYNC_CUSTOMERS_IDLE,
      payload: {
        message: '',
      },
    });
  };

  const handleCloseSyncCustomerModal = () => {
    setOpenSyncCustomers(false);
    dispatch({
      type: REDUX_ACTIONS.EPICOR_RIGS_SYNC_CUSTOMERS_IDLE,
      payload: {
        message: '',
      },
    });
  };

  const handleSyncCustomers = () => {
    dispatch(epicorSyncCustomers());
  };

  return <Box>
    <Box className={classes.container}>
    <Box>
        <IconButton
          onClick={() => {
            handleOpenModal();
          }}
          disabled={epicorBins.loading === true}
          sx={{ display: !isAdminUser && 'none' }}
        >
          <SyncRoundedIcon />
        </IconButton>
      </Box>
      <Box>
        <IconButton
          onClick={() => {
            handleOpenSyncShipsToModal();
          }}
          disabled={epicorBins.loading === true}
          sx={{ display: !isAdminUser && 'none' }}
        >
          <LocalShippingRounded />
        </IconButton>
      </Box>
      <Box>
        <IconButton
          onClick={() => {
            handleOpenSyncCustomerModal();
          }}
          disabled={epicorBins.loading === true}
          sx={{ display: !isAdminUser && 'none' }}
        >
          <Storefront />
        </IconButton>
      </Box>
      <Box>
        <IconButton
          onClick={() => {
            window.open(
              '/FieldBoxes/KPIs',
              '_blank'
            );
          }}
          disabled={epicorBins.loading === true}
          sx={{ display: !userKpiAccess && 'none' }}
        >
          <PieChartOutlineOutlined />
        </IconButton>
        <IconButton
          onClick={() => {
            handleAspectRatio(!preferences.aspectChanged);
          }}
          sx={{ display: ((user.type !== USER_TYPE.PREMIUM_SELECT_ADMIN && user.type !== USER_TYPE.PREMIUM_FIELD_TICKETING_USER) || (user.type === USER_TYPE.PREMIUM_SELECT_ADMIN && !containsAnyKeys([USER_TYPE.PREMIUM_FIELD_TICKETING_USER], user.accessLevels))) && 'none' }}
        >
          <AspectRatioRounded />
        </IconButton>
      </Box>
    </Box>
      {open
        ? (
        <SyncMobileDevicesModal
        open={open}
        onClose={handleCloseModal}
        handleClose={handleCloseModal}
        cta2Label={'Sync'}
        cta2Disabled={syncMobileDevices.syncStatus === 'loading'}
        cta2Action={handleSyncMobileDevices}
        showCta2={syncMobileDevices.syncResponseMessage !== 'Sync Completed'}
        showDateTimeRange={false}
        mobile={isMobile}
      >
        <CardMedia
          component="img"
          image={Premium}
          className={classes.logo}
        />

        <Typography variant="h3" gutterBottom component="div" className={classes.title}>
          Sync Mobile Devices?
        </Typography>

        { syncMobileDevices.syncResponseMessage !== ''
          ? <Typography variant="h5" gutterBottom component="div" className={classes.statusMessage}>
            {syncMobileDevices.syncResponseMessage}
          </Typography>
          : <div style={{
            height: 40,
          }}></div>
        }
      </SyncMobileDevicesModal>
          )
        : null}
      {openSyncShipsTo
        ? (
        <SyncMobileDevicesModal
        open={openSyncShipsTo}
        onClose={handleCloseSyncShipsToModal}
        handleClose={handleCloseSyncShipsToModal}
        cta2Label={'Sync'}
        cta2Disabled={syncMobileDevices.syncShipsToStatus === 'loading'}
        cta2Action={handleSyncShiptsTo}
        showCta2={syncMobileDevices.syncShipsToResponseMessage !== 'Sync Completed'}
        showDateTimeRange={false}
      >
        <CardMedia
          component="img"
          image={Premium}
          className={classes.logo}
        />

        <Typography variant="h3" gutterBottom component="div" className={classes.title}>
          Sync ShipTo ?
        </Typography>

        { syncMobileDevices.syncShipsToResponseMessage !== ''
          ? <Typography variant="h5" gutterBottom component="div" className={classes.statusMessage}>
            {syncMobileDevices.syncShipsToResponseMessage}
          </Typography>
          : <div style={{
            height: 40,
          }}></div>
        }
      </SyncMobileDevicesModal>
          )
        : null}
      {openSyncCustomers
        ? (
        <SyncMobileDevicesModal
        open={openSyncCustomers}
        onClose={handleCloseSyncCustomerModal}
        handleClose={handleCloseSyncCustomerModal}
        cta2Label={'Sync'}
        cta2Disabled={syncMobileDevices.syncCustomerStatus === 'loading'}
        cta2Action={handleSyncCustomers}
        showCta2={syncMobileDevices.syncCustomerResponseMessage !== 'Sync Completed'}
        showDateTimeRange={false}
      >
        <CardMedia
          component="img"
          image={Premium}
          className={classes.logo}
        />

        <Typography variant="h3" gutterBottom component="div" className={classes.title}>
          Sync Customers ?
        </Typography>

        { syncMobileDevices.syncCustomerResponseMessage !== ''
          ? <Typography variant="h5" gutterBottom component="div" className={classes.statusMessage}>
            {syncMobileDevices.syncCustomerResponseMessage}
          </Typography>
          : <div style={{
            height: 40,
          }}></div>
        }
      </SyncMobileDevicesModal>
          )
        : null}
    </Box>;
};

export default SyncMobileDevices;
